/*
 * Dynamiske variabler i produktbeskrivelsen.
 * Variabel-navnet ER option-navnet: skriv option-navnet i klammer, fx
 * [Antal paneler] eller [Batteristørrelse], evt. med beregning [Antal paneler x 0.39].
 * Værdierne kommer fra den valgte variant og opdateres live ved variant-skift.
 *
 * Matchning ignorerer store/små bogstaver og mellemrum, men IKKE stavefejl.
 *
 * Datakilde:
 *  - Ved indlæsning: <script data-variant-vars-config> (Liquid) med
 *    {names: [option-navne i rækkefølge], initial: [valgt variants option-værdier]}.
 *  - Ved variant-skift: temaets 'variant:change'-event (detail.variant.options).
 *
 * Regler:
 *  - Tal udtrækkes af værdien, så "6 kWh" -> 6 (skriv selv enheden i teksten).
 *  - Intet match (ukendt navn / manglende option) -> variablen bliver stående
 *    synligt, så shopejeren kan se at noget skal rettes.
 *  - Output på dansk: komma som decimal, punktum som tusind, maks 2 decimaler.
 */
(function () {
  var TOKEN_RE = /\[([^\]]+)\]/g;                       // alt mellem [ og ]
  var MULT_RE = /^(.+?)\s*[x×*]\s*([0-9.,]+)\s*$/;       // "navn x tal"

  // Normaliserer et navn til en opslagsnøgle: små bogstaver + fjern mellemrum/tegn.
  // (Stavefejl tolereres IKKE — så fejl bliver synlige og kan rettes.)
  function normalize(s) {
    return String(s)
      .toLowerCase()
      .replace(/[^a-z0-9æøå]+/g, '');
  }

  function formatNumber(n) {
    var rounded = Math.round(n * 100) / 100;
    return rounded.toLocaleString('da-DK', { maximumFractionDigits: 2 });
  }

  function numFrom(raw) {
    var n = parseFloat(String(raw).replace(',', '.')); // "6 kWh" -> 6
    return isNaN(n) ? null : n;
  }

  // Bygger { normaliseret-navn: rå-værdi } ud fra navne + værdier (samme rækkefølge).
  function buildMap(names, values) {
    var map = {};
    (names || []).forEach(function (name, i) {
      var v = (values || [])[i];
      if (v == null) return;
      map[normalize(name)] = v;
    });
    return map;
  }

  // Erstatter alle [tokens] i en tekst ud fra map'en.
  function replaceVars(text, map) {
    return text.replace(TOKEN_RE, function (full, inner) {
      var name = inner;
      var mult = null;
      var m = inner.match(MULT_RE);
      if (m) { name = m[1]; mult = m[2]; }

      var raw = map[normalize(name)];
      if (raw === undefined) return full;          // intet match -> lad token stå (synlig fejl)
      var base = numFrom(raw);

      if (mult !== null) {                          // beregning
        if (base === null) return full;            // kan ikke regne -> lad token stå
        var f = parseFloat(String(mult).replace(',', '.'));
        if (isNaN(f)) return full;
        return formatNumber(base * f);
      }
      // uden beregning: vis tallet hvis numerisk, ellers den rå værdi
      return base !== null ? formatNumber(base) : String(raw);
    });
  }

  if (typeof document !== 'undefined') {
    // Går alle tekstknuder igennem og erstatter tokens. Gemmer originalen
    // pr. knude, så vi altid kan gen-rendere ved variant-skift.
    function render(root, map) {
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
      var node;
      while ((node = walker.nextNode())) {
        if (node._vvOrig === undefined) node._vvOrig = node.nodeValue;
        if (node._vvOrig.indexOf('[') === -1) continue;
        node.nodeValue = replaceVars(node._vvOrig, map);
      }
    }

    var config = null;
    function getConfig() {
      if (config) return config;
      var el = document.querySelector('[data-variant-vars-config]');
      if (!el) return null;
      try { config = JSON.parse(el.textContent); } catch (e) { config = null; }
      return config;
    }

    function renderAll(map) {
      var containers = document.querySelectorAll('[data-variant-vars]');
      for (var i = 0; i < containers.length; i++) render(containers[i], map);
    }

    function init() {
      var cfg = getConfig();
      if (!cfg) return;
      renderAll(buildMap(cfg.names, cfg.initial));
    }

    document.addEventListener('variant:change', function (e) {
      var cfg = getConfig();
      if (!cfg || !e.detail || !e.detail.variant) return;
      renderAll(buildMap(cfg.names, e.detail.variant.options || []));
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  }

  // Eksponér rene funktioner til test i node.
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { replaceVars: replaceVars, buildMap: buildMap, normalize: normalize, formatNumber: formatNumber };
  }
})();
